import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { cancelTriggerOrder } from '../../../store/actions/triggerOrders/triggerOrdersActions';
import { portfolioFinancialPendingTransactions } from '../../../store/actions/portfolio/portfolioActions';
import { CANCEL_TRIGGER_ORDER_LOADING } from '../../../store/actions/triggerOrders/triggerOrdersActionConstants';
import { selectIsLoadingByActionType } from '../../../store/selectors/loadingSelectors';
import { formatMoneyNumeral } from '../../../util/helpers/numeralHelpers';
import tokens from '../../../assets/styles/tokens';
import SectionLoader from '../../Loader/SectionLoader';
import ModalButtons from '../../Modal/ModalButtons';
import Paragraph from '../../Paragraph/Paragraph';
import ModalBody from '../../Modal/ModalBody';

const CancelTriggerOrderText = styled(Paragraph)`
  ${tokens.type.body[300]}
  text-align: center;
`;

const CancelTriggerOrder = ({
  setError,
  handleNext,
  handleClose,
  cancelTransactionData,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { paymentUid, accountUid, amount } = cancelTransactionData;
  const isLoading = useSelector(
    selectIsLoadingByActionType(CANCEL_TRIGGER_ORDER_LOADING),
  );

  const refreshTransactions = () => {
    dispatch(portfolioFinancialPendingTransactions({ accountUid }));
  };

  const handleCancelTriggerOrder = () => {
    dispatch(
      cancelTriggerOrder({
        accountUid,
        triggerOrderUid: paymentUid,
        onSuccess: () => {
          setError('');
          refreshTransactions();
          handleNext();
        },
        onError: (errorMessage) => {
          setError(errorMessage);
          handleNext();
        },
      }),
    );
  };

  return (
    <SectionLoader isLoading={isLoading}>
      <ModalBody>
        <CancelTriggerOrderText>
          {t('portfolio.pendingTransactions.cancelTriggerOrder.text', {
            amount: formatMoneyNumeral(amount),
          })}
        </CancelTriggerOrderText>
        <ModalButtons
          isHorizontal
          marginTop
          secondaryButtonProps={{
            onClick: handleCancelTriggerOrder,
            label: t(
              'portfolio.pendingTransactions.cancelTriggerOrder.yesCancel',
            ),
            textTransform: 'capitalize',
          }}
          primaryButtonProps={{
            onClick: handleClose,
            label: t(
              'portfolio.pendingTransactions.cancelTriggerOrder.noKeepIt',
            ),
            textTransform: 'capitalize',
          }}
        />
      </ModalBody>
    </SectionLoader>
  );
};

CancelTriggerOrder.propTypes = {
  setError: PropTypes.func,
  handleNext: PropTypes.func,
  handleClose: PropTypes.func,
  cancelTransactionData: PropTypes.shape({
    paymentUid: PropTypes.string,
    accountUid: PropTypes.string,
    amount: PropTypes.number,
  }),
};

export default CancelTriggerOrder;
